import Thompson1 from '../Thomson/Thomson (1).webp'
import Thompson2 from '../Thomson/Thomson (2).webp'
import Thompson3 from '../Thomson/Thomson (3).webp'
import Thompson4 from '../Thomson/Thomson (4).webp'
import Thompson5 from '../Thomson/Thomson (5).webp'
import Thompson6 from '../Thomson/Thomson (6).webp'
import Thompson7 from '../Thomson/Thomson (7).webp'
import Thompson8 from '../Thomson/Thomson (8).webp'
import Thompson9 from '../Thomson/Thomson (9).webp'
import Thompson10 from '../Thomson/Thomson (10).webp'


const Thompsonimages =[
Thompson1,Thompson2,Thompson3,Thompson4,Thompson5,Thompson6,Thompson7,Thompson8,Thompson9,Thompson10
]

export default Thompsonimages;